import { Clock, Users, ExternalLink } from "lucide-react";

const Experiences = () => {
  const experiences = [
    {
      id: 1,
      title: "Kayak & Wildlife Tour",
      duration: "2.5 hours",
      price: "$85 per person",
      maxGuests: "Max 8 guests",
      description:
        "Paddle through the calm waterways of Bribie Island, spotting local wildlife and learning the stories behind one of Queensland's most underrated island destinations.",
      image: "https://images.unsplash.com/photo-1544551763-46a013bb70d5?w=600&q=80",
    },
    {
      id: 2,
      title: "Bribie Foodie Walk",
      duration: "2 hours",
      price: "$65 per person",
      maxGuests: "Max 10 guests",
      description:
        "A curated walk through Bribie Village discovering the island's best cafés, providores, and hidden culinary gems — led by someone who actually eats here every day.",
      image: "https://images.unsplash.com/photo-1414235077428-338989a2e8c0?w=600&q=80",
    },
    {
      id: 3,
      title: "Sunset Photography Walk",
      duration: "2 hours",
      price: "$75 per person",
      maxGuests: "Max 6 guests",
      description:
        "Golden hour on Bribie Island is something else. We take you to the best vantage points at exactly the right time, with tips for capturing the light on any phone or camera.",
      image: "https://images.unsplash.com/photo-1507400492013-162706c8c05e?w=600&q=80",
    },
  ];

  return (
    <section
      id="experiences"
      data-testid="experiences-section"
      className="section-padding bg-cream"
    >
      <div className="container-custom">
        {/* Section Header */}
        <div className="grid lg:grid-cols-2 gap-8 lg:gap-16 mb-16">
          <div>
            <p className="text-xs uppercase tracking-[0.2em] text-coral font-semibold mb-4">
              Local Experiences
            </p>
            <h2 className="section-heading">
              Explore Bribie Island with a local
            </h2>
          </div>
          <div className="flex items-end">
            <p className="text-bark-light text-lg leading-relaxed">
              More than just a place to stay — Bribie Island is a destination
              worth exploring. Join one of our small-group experiences and see
              the island through the eyes of someone who calls it home.
            </p>
          </div>
        </div>

        {/* Experience Cards */}
        <div className="grid md:grid-cols-3 gap-8">
          {experiences.map((experience) => (
            <div
              key={experience.id}
              className="experience-card group"
              data-testid={`experience-card-${experience.id}`}
            >
              {/* Image */}
              <div className="img-zoom aspect-[4/3]">
                <img
                  src={experience.image}
                  alt={experience.title}
                  className="w-full h-full object-cover"
                />
              </div>

              {/* Content */}
              <div className="p-6 lg:p-8">
                <h3 className="text-xl font-serif text-bark mb-3">
                  {experience.title}
                </h3>

                {/* Meta */}
                <div className="flex flex-wrap gap-4 text-sm text-bark-light mb-4">
                  <span className="flex items-center gap-1">
                    <Clock size={14} />
                    {experience.duration}
                  </span>
                  <span className="flex items-center gap-1">
                    <Users size={14} />
                    {experience.maxGuests}
                  </span>
                </div>

                {/* Price */}
                <p className="text-coral font-semibold mb-4">
                  {experience.price}
                </p>

                {/* Description */}
                <p className="text-sm text-bark-light leading-relaxed mb-6">
                  {experience.description}
                </p>

                {/* CTA */}
                <a
                  href="https://airbnb.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn-coral inline-flex items-center gap-2 text-xs"
                  data-testid={`experience-book-${experience.id}`}
                >
                  Book on Airbnb
                  <ExternalLink size={14} />
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Experiences;
